import axios from 'axios'

import type { IntakeFormRefusal, TemplateIssue } from '@/definitions/intakeForm'

const isIssue = (value: unknown): value is TemplateIssue =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as TemplateIssue).code === 'string' &&
  typeof (value as TemplateIssue).message === 'string'

const issuesAt = (body: Record<string, unknown>, key: string): TemplateIssue[] | undefined => {
  const value = body[key]
  return Array.isArray(value) && value.every(isIssue) ? value : undefined
}

/**
 * The named refusal behind a failed write, or null for anything else.
 *
 * Null covers a transport failure and a refusal from outside this API alike — both
 * mean there is nothing here to show against the definition, so the caller falls
 * back to a plain message.
 */
export const readRefusal = (error: unknown): IntakeFormRefusal | null => {
  if (!axios.isAxiosError(error)) {
    return null
  }
  const body: unknown = error.response?.data
  if (typeof body !== 'object' || body === null) {
    return null
  }
  const { message, code } = body as { message?: unknown; code?: unknown }
  if (typeof message !== 'string' || typeof code !== 'string') {
    return null
  }
  return {
    message,
    code,
    errors: issuesAt(body as Record<string, unknown>, 'errors'),
    warnings: issuesAt(body as Record<string, unknown>, 'warnings'),
  }
}
